import React from 'react';
import axios from 'axios';
import Input from 'material-ui/Input';
import InputLabel from 'material-ui/Input/InputLabel';
import FormControl from 'material-ui/Form/FormControl';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import Grid from 'material-ui/Grid';
import ReCaptcha from 'react-google-recaptcha';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';
import CheckCircle from 'material-ui-icons/CheckCircle';

export default class ContactForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      style: {
        halfInput: {
          minWidth: '200px',
        },
        formControl: {
          margin: '16px 0 8px 0',
        },
        section: {
          backgroundColor: '#F4F4F4',
        },
        recaptcha: {
          float: 'left',
        },
        bullets: {
          width: '24px',
          height: '24px',
          color: '#47b10b',
          position: 'absolute',
          top: 0,
          left: 0,
        },
        bullettext: {
          position: 'relative',
          paddingLeft: '35px',
        }
      },
      contact: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
      errors: {
        name: false,
        email: false,
        subject: false,
        message: false,
      },
      captchaEnabled: true,
      open: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.recaptcha = this.recaptcha.bind(this);
  }

  handleChange(e) {
    const key = e.target.id;
    const value = e.target.value;
    const contact = this.state.contact;
    contact[key] = value;
    this.setState(contact);
  }

  handleClick() {
    this.contact = this.state.contact;
    // Validation
    const errors = this.state.errors;
    let waserror = false;
    if (!this.contact.name) {
      errors.name = true;
      waserror = true;
    } else {
      errors.name = false;
    }
    if (!this.contact.email || !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.contact.email)) {
      errors.email = true;
      waserror = true;
    } else {
      errors.email = false;
    }
    if (!this.contact.subject) {
      errors.subject = true;
      waserror = true;
    } else {
      errors.subject = false;
    }
    if (!this.contact.message) {
      errors.message = true;
      waserror = true;
    } else {
      errors.message = false;
    }

    if (waserror) {
      this.setState({ errors });
      return;
    }

    this.emailBody = `Name: ${this.contact.name}\r\nEmail: ${this.contact.email}\r\nSubject: ${this.contact.subject}\r\nMessage: ${this.contact.message}`;

    axios.post('/api/email', {
      text: this.emailBody,
      html: this.emailBody,
    })
    .then((response) => {
      if (response.data.message === 'sent') {
        this.setState({ open: true });
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  handleRequestClose() {
    this.setState({ open: false });
  }

  recaptcha(value) {
    if (value !== 'null') {
      this.setState({
        captchaEnabled: false,
      });
    } else {
      this.setState({
        captchaEnabled: true,
      });
    }
  }

  render() {
    return (
      <div className="section full-width" style={this.state.style.section} id="contact-us">
        <div className="inner">
          <Typography
            align="left"
            type="title"
            style={{ marginBottom: '20px' }}
          >
            Contact Us
          </Typography>
          <div style={this.state.style.form} className="contact-col right">
            <div style={this.state.style.formControl}>
              <Grid container>
                <Grid item xs style={this.state.style.halfInput}>
                  <FormControl
                    fullWidth
                    error={this.state.errors.name}
                  >
                    <InputLabel htmlFor="name">Name</InputLabel>
                    <Input
                      id="name"
                      value={this.state.contact.name}
                      onChange={this.handleChange}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs style={this.state.style.halfInput}>
                  <FormControl
                    fullWidth
                    error={this.state.errors.email}
                  >
                    <InputLabel htmlFor="email">Email</InputLabel>
                    <Input
                      id="email"
                      value={this.state.contact.email}
                      onChange={this.handleChange}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </div>
            <FormControl
              fullWidth
              style={this.state.style.formControl}
              error={this.state.errors.subject}
            >
              <InputLabel htmlFor="subject">Subject</InputLabel>
              <Input
                id="subject"
                value={this.state.contact.subject}
                onChange={this.handleChange}
              />
            </FormControl>
            <TextField
              id="message"
              label="Message"
              multiline
              rowsMax="4"
              margin="normal"
              fullWidth
              value={this.state.contact.message}
              error={this.state.errors.message}
              onChange={this.handleChange}
            />
            <ReCaptcha
              ref="recaptcha"
              className="recaptcha"
              sitekey="6LfeIiwUAAAAACd-c0s2TSSB5-tgSOJaMxytPbWj"
              onChange={this.recaptcha}
              style={this.state.style.recaptcha}
            />
            <Button
              raised
              color="primary"
              className="button-cta"
              style={{ marginTop: '16px', float: 'right' }}
              onClick={this.handleClick}
              disabled={this.state.captchaEnabled}
            >
              Send
            </Button>

          </div>
          <div className="contact-col">
            <Typography component="p">
              Looking for a professional, dedicated, and down-to-earth web team?<br /><br />

              You&apos;ve come to the right place. We provide peace of mind to our
              clients through our excellent skills in communication, collaboration,
              and of course, code.<br /><br />

              When you choose All Bits On as your development partner, you get:<br /><br />
            </Typography>
            <Typography type="body1" style={this.state.style.bullettext}>
              <CheckCircle style={this.state.style.bullets} />
              A partnership that&apos;s structured, but also flexible.<br /><br />
            </Typography>
            <Typography type="body1" style={this.state.style.bullettext}>
              <CheckCircle style={this.state.style.bullets} />
              A team who has great experience not only developing solutions from the ground
              up, but also managing and reworking already existing code bases.<br /><br />
            </Typography>
            <Typography type="body1" style={this.state.style.bullettext}>
              <CheckCircle style={this.state.style.bullets} />
              Solution designs that don&apos;t just function, but also focus on
              user experience and conversions.<br /><br />
            </Typography>
            <Typography type="body1">
              We love talking with businesses about their projects and goals.
              We look forward to hearing from you!<br /><br />
            </Typography>
          </div>
          <div className="clear" />
        </div>
        <Dialog open={this.state.open} onRequestClose={this.handleRequestClose}>
          <DialogTitle>
            Thanks!
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              We have succesfully received your email, and will get back to you as soon as possible.
              We look forward to talking with you!
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleRequestClose} color="primary">
              Awesome!
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/form/contact.js